import React, { useReducer, useEffect, useState, useRef } from "react";
import SectionHeader from "../../../components/SectionHeader/SectionHeader";
import ErrorFooter from "../../../components/ErrorFooter/ErrorFooter";
import "../../../components/ErrorFooter/ErrorFooter.css";
import { useFormContext } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { request, handleErrors } from "../../../services/helpers";
import classNames from "classnames";
import { LinearProgress } from "@material-ui/core";
import { Autocomplete } from "../../../components/AutoComplete/AutoComplete";
import moment from "moment";

import axios from "axios";
// this component and all it's children assumes you are working with `react-hook-form`
// form library. Will crash without using the library.

const inputClass =
  "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500";

const inputErrorClass = "border border-red-500 b-2 text-red-500";
const labelClass =
  "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

const SET_FORM_LOADING = "SET_FORM_LOADING";

// const FORM_DATA_REQUEST = "FORM_DATA_REQUEST";
const FORM_DATA_SUCCESS = "FORM_DATA_SUCCESS";
const FORM_DATA_FAILURE = "FORM_DATA_FAILURE";

const FORM_SUBMIT_SUCCESS = "FORM_SUBMIT_SUCCESS";
const FORM_SUBMIT_FAILURE = "FORM_SUBMIT_FAILURE";

const initialState = {
  eventName: null,
  eventZoners: [],
  notificationTimelines: [],
  eventLocation: null,
  eventTagline: null,
  meetingLink: null,
  hostingSite: null,
  zoomLink: null,
  eventBanner: null,
  eventDateTime: null,
  eventEndDateTime: null,
  eventDescription: null,
  eventDisclaimer: null,
  showEventDisclaimer: false,
  learningIcon_1_desc: null,
  learningIcon_1_link: null,
  learningIcon_2_desc: null,
  learningIcon_2_link: null,
  hostName: null,
  hostDescription: null,
  hostCredential: null,
  disclaimer: null,
  loading: false,
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM_LOADING:
      return {
        ...state,
        loading: action.payload === false ? action.payload : true,
      };

    case FORM_DATA_SUCCESS: {
      return {
        ...state,
        locations: action.payload.locations,
        additionalServices: action.payload.additionalServices,
        membershipTypes: action.payload.membershipTypes,
        loading: false,
      };
    }

    case FORM_DATA_FAILURE: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }

    case FORM_SUBMIT_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }

    case FORM_SUBMIT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

const AddEvent = () => {
  const {
    watch,
    handleSubmit,
    errors,
    register,
    control,
    reset,
    setValue,
  } = useFormContext();

  const locationHook = useLocation();

  const [formState, dispatch] = useReducer(reducer, initialState);
  const [imageLoading, setImageLoading] = useState(false);
  let [tagsCounter, setTagCounter] = useState(0);
  let [timeTagsCounter, setTimeCounter] = useState(0);
  const [editLocation, setEditLocation] = useState(null);

  const eventId = locationHook.state ? locationHook.state[0].eventId : null;

  const fetchEventDetails = async (id) => {
    const res = await request.get(`event/list?eventId=${id}`);
    return res;
  };

  const fetchLocations = async () => {
    const res = await request.get("/buildings");
    return res;
  };

  /* Image upload */
  const defaultImage = "https://i.ibb.co/rbrwyF6/event-banner-placeholder.png";
  const [image, setImage] = useState(defaultImage);
  const [learningIconOne, setLearningIconOne] = useState(defaultImage);
  const [learningIconTwo, setLearningIconTwo] = useState(defaultImage);
  const [hostProfilePicture, setHostProfilePicture] = useState(defaultImage);
  const [eventBannerImg, setEventBannerImg] = useState(defaultImage);
  const [eventLearningIconOne, setEventLearningIconOne] = useState(
    defaultImage
  );
  const [eventLearningIconTwo, setEventLearningIconTwo] = useState(
    defaultImage
  );
  const [eventHostPic, setEventHostPic] = useState(defaultImage);

  const getImageURL = async (selectedFile) => {
    const response = await request.get(
      `/upload?contenttype=${selectedFile.type}&filename=${selectedFile.name}&resourcetype=events`
    );
    const { url } = await response.data;
    const serverResponse = await axios.put(url, selectedFile, {
      headers: { "Content-Type": selectedFile.type },
    });
    console.log(`serverResponse: ${JSON.stringify(serverResponse)}`);
    return serverResponse;
  };

  const handleImageClick = (e) => {
    e.preventDefault();
    console.log(e.target.id);
    switch (e.target.id) {
      case "eventBanner":
        document.getElementById("eventBanner").click();
        break;
      case "learningIcon1":
        document.getElementById("learningIconOne").click();
        break;
      case "learningIcon2":
        document.getElementById("learningIconTwo").click();
        break;
      case "hostProfilePic":
        document.getElementById("hostProfilePicture").click();
        break;
    }
  };

  const handleImageChange = async (e) => {
    setImageLoading(true);
    console.log(e.target.name);
    let selectedFile, objectUrl;
    /* set the corresponding URL field value to null */
    switch (e.target.name) {
      case "eventBanner":
        document.getElementById("event-banner").value = "";
        selectedFile = e.target.files[0];
        objectUrl = URL.createObjectURL(selectedFile);
        setEventBannerImg(selectedFile);
        setImage(objectUrl);
        break;
      case "learningIconOne":
        document.getElementById("learning-icon-1-link").value = "";
        selectedFile = e.target.files[0];
        objectUrl = URL.createObjectURL(selectedFile);
        setEventLearningIconOne(selectedFile);
        setLearningIconOne(objectUrl);
        break;
      case "learningIconTwo":
        document.getElementById("learning-icon-2-link").value = "";
        selectedFile = e.target.files[0];
        objectUrl = URL.createObjectURL(selectedFile);
        setEventLearningIconTwo(selectedFile);
        setLearningIconTwo(objectUrl);
        break;
      case "hostProfilePicture":
        document.getElementById("host-pic-url").value = "";
        selectedFile = e.target.files[0];
        objectUrl = URL.createObjectURL(selectedFile);
        setEventHostPic(selectedFile);
        setHostProfilePicture(objectUrl);
        break;
    }
    setImageLoading(false);
  };

  const getLocationIndex = (id) => {
    for (let i = 0; i < locations.length; i++) {
      if (locations[i]._id === id) {
        return i;
      }
    }
    return 3;
  };

  const eventOnlineLocation = { name: "Online", _id: "0" };
  //these are to be fetched from DB
  const eventCategories = [
    "🤸🏻‍♀️ Fun",
    "🚀 Startup Circle",
    "👨‍⚕️ Health",
    "🖥 Technology",
    "🤙 Team Dynamics",
    "✌️ Wellness",
    "🎟 Sales & Marketing",
    "🗼 Architecture",
    "💽 Culture",
    "🤝 Networking",
  ];
  //convert array of strings into array of objects and store in state
  const [categoryTags, setCategoryTags] = useState(
    eventCategories.map((cat, i) => {
      return { text: cat, selected: false, _id: i };
    })
  );

  //these are to be fetched from DB
  const timeTagsArr = [
    "02 days",
    "01 day",
    "12 hours",
    "06 hours",
    "02 hours",
    "01 hour",
    "45 mins",
    "30 mins",
    "15 mins",
  ];
  //convert array of strings into array of objects and store in state
  const [timeTags, setTimeTags] = useState(
    timeTagsArr.map((time, i) => {
      return { text: time, selected: false, _id: i };
    })
  );

  const [locations, setLocations] = useState([]);

  useEffect(() => {
    if (eventId) {
      fetchEventDetails(eventId)
        .then((res) => {
          if (res?.data?.length > 0) {
            const eventDetails = res.data[0];
            const eventFormData = {
              eventName: eventDetails.eventName,
              //eventZoners: eventDetails.eventZoner,
              notificationTimelines: eventDetails.notificationTimes,
              eventTagline: eventDetails.eventTagLine,
              meetingLink: eventDetails.meetingLink,
              hostingSite: eventDetails.hostingSite,
              eventBanner: eventDetails.eventBanner,
              eventDateTime: moment(eventDetails.eventDate).format(
                "yyyy-MM-DDThh:mm"
              ),
              eventEndDateTime: moment(eventDetails.eventEndDate).format(
                "yyyy-MM-DDThh:mm"
              ),
              eventDescription: eventDetails.eventDescription,
              eventDisclaimer: eventDetails.eventDisclaimer,
              showEventDisclaimer: eventDetails.eventDisclaimer ? true : false,
              learningIcon_1_desc: eventDetails.eventlearnings[0].description,
              learningIcon_1_link: eventDetails.eventlearnings[0].icon,
              learningIcon_2_desc: eventDetails.eventlearnings[1].description,
              learningIcon_2_link: eventDetails.eventlearnings[1].icon,
              hostName: eventDetails.speakerDetails.name,
              hostDescription: eventDetails.speakerDetails.bio,
              hostCredentials: eventDetails.speakerDetails.credential,
              hostPicUrl: eventDetails.speakerDetails.picture,
              disclaimer: eventDetails.eventDisclaimer,
            };
            reset(eventFormData);
            setImage(eventDetails.eventBanner);

            if (eventDetails && eventDetails.buildingId) {
              setEditLocation(eventDetails.buildingId);
              setValue("eventLocation", eventDetails.buildingId);
            } else {
              setEditLocation("0");
              setValue("eventLocation", "0");
            }

            eventDetails.eventZoner.forEach((zone) => {
              const tempArr = categoryTags.map((l, i) => {
                if (zone === l.text) {
                  l.selected = true;
                  setTagCounter(tagsCounter + 1);
                }
                return l;
              });
              setCategoryTags(tempArr);
            });

            eventDetails.notificationTimes.forEach((time) => {
              const tempArr = timeTags.map((l, i) => {
                console.log(moment(time).format("yyyy-MM-DDThh:mm:ss.sssZ"));
                console.log(
                  moment(eventDetails.eventDate)
                    .subtract(parseInt(l.text.slice(0, 2)), l.text.slice(3, 4))
                    .format("yyyy-MM-DDThh:mm:ss.sssZ")
                );
                console.log(
                  moment(time).format("yyyy-MM-DDThh:mm:ss.sssZ") ===
                    moment(eventDetails.eventDate)
                      .subtract(
                        parseInt(l.text.slice(0, 2)),
                        l.text.slice(3, 4)
                      )
                      .format("yyyy-MM-DDThh:mm:ss.sssZ")
                );
                if (
                  moment(time).format("yyyy-MM-DDThh:mm:ss.sssZ") ===
                  moment(eventDetails.eventDate)
                    .subtract(parseInt(l.text.slice(0, 2)), l.text.slice(3, 4))
                    .format("yyyy-MM-DDThh:mm:ss.sssZ")
                ) {
                  l.selected = true;
                  setTimeCounter(timeTagsCounter + 1);
                }
                return l;
              });
              setTimeTags(tempArr);
            });
          }
        })
        .catch((e) => console.error(e));
    }
  }, [eventId]);

  useEffect(() => {
    //fetch available event locations from DB and add online option for the location dropdown
    fetchLocations()
      .then((result) => {
        const tempLocations = result.data;
        tempLocations.push(eventOnlineLocation);
        setLocations(tempLocations);
      })
      .catch((e) => console.error(e));
  }, []);

  let location = watch("eventLocation");
  let showEventDisclaimer = watch("showEventDisclaimer");
  let learningIcon_1 = watch("learningIcon_1_link");
  let learningIcon_2 = watch("learningIcon_2_link");
  let hostPicUrl = watch("hostPicUrl");
  let eventBannerUrl = watch("eventBanner");

  const history = useHistory();
  const { error, loading } = formState;

  const toggleTagSelectedState = (index) => {
    if (tagsCounter < 3 || categoryTags[index].selected) {
      const tempTagsArray = categoryTags;
      tempTagsArray[index].selected = !tempTagsArray[index].selected;
      if (categoryTags[index].selected) {
        setTagCounter(tagsCounter + 1);
      } else {
        setTagCounter(tagsCounter - 1);
      }
      setCategoryTags(tempTagsArray);
    }
  };

  const toggleTimeTagSelectedState = (index) => {
    if (timeTagsCounter < 3 || timeTags[index].selected) {
      const tempTagsArray = timeTags;
      tempTagsArray[index].selected = !tempTagsArray[index].selected;
      if (timeTags[index].selected) {
        setTimeCounter(timeTagsCounter + 1);
      } else {
        setTimeCounter(timeTagsCounter - 1);
      }
      setTimeTags(tempTagsArray);
    }
  };

  const handleCreateEvent = async (data) => {
    dispatch({
      type: SET_FORM_LOADING,
    });

    try {
      let {
        eventName,
        eventDateTime,
        eventEndDateTime,
        eventLocation,
        eventDescription,
        eventDisclaimer,
        eventBanner,
        eventTagline,
        hostingSite,
        meetingLink,
        zoomLink,
        learningIcon_1_desc,
        learningIcon_1_link,
        learningIcon_2_desc,
        learningIcon_2_link,
        hostCredentials,
        hostName,
        hostDescription,
        hostPicUrl,
      } = data;

      if (!eventBanner) {
        let newUrl = await getImageURL(eventBannerImg);
        let { url } = newUrl.config;
        eventBanner = url.split("?")[0];
      }

      if (!learningIcon_1_link) {
        let newUrl = await getImageURL(eventLearningIconOne);
        let { url } = newUrl.config;
        learningIcon_1_link = url.split("?")[0];
      }

      if (!learningIcon_2_link) {
        let newUrl = await getImageURL(eventLearningIconTwo);
        let { url } = newUrl.config;
        learningIcon_2_link = url.split("?")[0];
      }

      if (!hostPicUrl) {
        let newUrl = await getImageURL(eventHostPic);
        let { url } = newUrl.config;
        hostPicUrl = url.split("?")[0];
      }

      const tags = categoryTags.filter((tag) => tag.selected === true);
      const eventZoner = [];
      tags.forEach((tag) => {
        eventZoner.push(tag.text);
      });

      const timeArr = timeTags.filter((tag) => tag.selected === true);
      const notificationTimes = [];
      timeArr.forEach((tag) => {
        notificationTimes.push(
          moment(eventDateTime).subtract(
            parseInt(tag.text.slice(0, 2)),
            tag.text.slice(3, 4)
          )
        );
      });

      let formData = {
        eventName,
        eventDate: eventDateTime,
        eventEndDate: eventEndDateTime,
        eventDescription,
        eventBanner,
        eventTagLine: eventTagline,
        eventPictures: [],
        eventZoner: eventZoner,
        notificationTimes: notificationTimes,
        hostingSite,
        meetingLink,
        eventlearnings: [
          { icon: learningIcon_1_link, description: learningIcon_1_desc },
          { icon: learningIcon_2_link, description: learningIcon_2_desc },
        ],
        meetLinks: {
          zoom: zoomLink,
        },
        speakerDetails: {
          name: hostName,
          picture: hostPicUrl,
          bio: hostDescription,
          credential: hostCredentials,
        },
      };

      if (eventLocation !== "0") {
        formData.buildingId = eventLocation;
      }

      if (eventDisclaimer) {
        formData.eventDisclaimer = eventDisclaimer;
      }

      dispatch({
        type: SET_FORM_LOADING,
        payload: false,
      });
      let res;

      if (eventId) {
        res = await request
          .post(`/event?eventId=${eventId}`, formData)
          .then((response) => {
            console.log(response);
          });
      } else {
        res = await request.post("/event", formData).then((response) => {
          console.log(response);
        });
      }
      dispatch({
        type: FORM_SUBMIT_SUCCESS,
      });
      history.push("/events");
    } catch (e) {
      dispatch({
        type: FORM_SUBMIT_FAILURE,
        payload: handleErrors(e),
      });
    }
  };

  return (
    <div className="bg-formBackground">
      <div className="bg-formBackground">
        <SectionHeader
          path={["dashboard", "add a new event"]}
          title={"Add a new event"}
        />

        <form onSubmit={handleSubmit(handleCreateEvent)} className="pb-24">
          <div className="lg:px-32 px-8 mt-16">
            <div className="lg:flex my-16">
              <div className="lg:mr-6 max-w-xs">
                <h4 className="font-medium text-2xl leading-7">
                  Event Information
                </h4>
              </div>
              <div className="lg:mt-0 mr-24 my-8 w-full">
                <div className="md:w-full w-full mb-6">
                  <input
                    onChange={handleImageChange}
                    id="eventBanner"
                    type="file"
                    name="eventBanner"
                    hidden
                  />
                  {imageLoading && <LinearProgress />}
                  <div onClick={handleImageClick}>
                    <img
                      width="100%"
                      height="250"
                      src={
                        image
                        // || "https://i.ibb.co/rbrwyF6/event-banner-placeholder.png"
                      }
                      id="eventBanner"
                      alt="event-banner-placeholder"
                      border="0"
                    />
                  </div>
                </div>
                <div className="md:w-1/2 w-full mb-6 md:pr-4">
                  <label className={labelClass} htmlFor="event-name">
                    Event Name
                  </label>
                  <input
                    className={classNames({
                      [inputClass]: true,
                      [inputErrorClass]:
                        errors.eventName && errors.eventName.message,
                    })}
                    id="event-name"
                    type="text"
                    placeholder="Add an event name"
                    name="eventName"
                    ref={register}
                  />
                  {errors.eventName && errors.eventName.message && (
                    <div className="text-xs text-red-500 flex flex-row-reverse">
                      <span>{errors.eventName.message}</span>
                    </div>
                  )}
                </div>

                <div className="md:flex">
                  <div className="w-full mb-6 pr-4">
                    <label className={labelClass} htmlFor="event-name">
                      Select a tag (Upto 3 tags)
                    </label>
                    {categoryTags.map((tag, i) => (
                      <button
                        className={classNames(
                          "px-2 py-2 mr-2 mb-2 rounded-sm",
                          {
                            "bg-tagBackground": !tag.selected,
                          },
                          {
                            "bg-white border-black border-2 border-solid":
                              tag.selected,
                          }
                        )}
                        key={i}
                        type="button"
                        onClick={() => {
                          toggleTagSelectedState(i);
                        }}
                      >
                        {tag.text}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="md:flex">
                  <div className="md:w-1/2 w-full mb-6 md:pr-4">
                    <label className={labelClass} htmlFor="event-tagline">
                      Event Tagline
                    </label>
                    <input
                      className={classNames({
                        [inputClass]: true,
                        [inputErrorClass]:
                          errors.eventTagline && errors.eventTagline.message,
                      })}
                      id="event-tagline"
                      type="text"
                      placeholder="Add an event tagline"
                      name="eventTagline"
                      ref={register}
                    />
                    {errors.eventTagline && errors.eventTagline.message && (
                      <div className="text-xs text-red-500 flex flex-row-reverse">
                        <span>{errors.eventTagline.message}</span>
                      </div>
                    )}
                  </div>
                  <div className="md:w-1/2 w-full mb-6">
                    <label className={labelClass} htmlFor="event-banner">
                      Event Banner URL (Optional)
                    </label>
                    <input
                      className={classNames({
                        [inputClass]: true,
                        [inputErrorClass]:
                          errors.eventBanner && errors.eventBanner.message,
                      })}
                      id="event-banner"
                      type="text"
                      placeholder="Add an event banner URL"
                      onChange={() => {
                        setImage(eventBannerUrl);
                        eventBannerUrl = "";
                      }}
                      name="eventBanner"
                      ref={register}
                    />
                    {errors.eventBanner && errors.eventBanner.message && (
                      <div className="text-xs text-red-500 flex flex-row-reverse">
                        <span>{errors.eventBanner.message}</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="md:flex">
                  <div className="md:w-1/2 w-full mb-6 pr-4">
                    <label className={labelClass} htmlFor="event-location">
                      Event Location
                    </label>
                    <Autocomplete
                      control={control}
                      name="eventLocation"
                      getOptionLabel={(option) => {
                        if (typeof option === "string") {
                          let x;
                          locations.forEach((l) => {
                            if (l._id === option) {
                              x = l.name;
                            }
                          });
                          console.log(x);
                          console.log(typeof x);
                          return x;
                        } else {
                          return option.name;
                        }
                      }}
                      value={location}
                      options={locations || []}
                      textFieldProps={{ placeholder: "Select A Center" }}
                      onChange={(val, data) => {
                        if (data && data._id) {
                          setValue("eventLocation", data._id);
                          return data._id;
                        } else {
                          setValue("eventLocation", null);
                          return null;
                        }
                      }}
                    />
                    {errors.eventLocation && errors.eventLocation.message && (
                      <div className="text-xs text-red-500 flex flex-row-reverse">
                        <span>{errors.eventLocation.message}</span>
                      </div>
                    )}
                  </div>
                  <div className="md:w-1/2 w-full mb-6 md:ml-6">
                    <label className={labelClass} htmlFor="event-date">
                      Select Date & Time
                    </label>
                    <input
                      className={classNames({
                        [inputClass]: true,
                        [inputErrorClass]:
                          errors.eventDateTime && errors.eventDateTime.message,
                      })}
                      type="datetime-local"
                      id="event-date"
                      placeholder="Event date"
                      disabled={eventId ? true : false}
                      name="eventDateTime"
                      ref={register}
                    />
                    {errors.eventDateTime && errors.eventDateTime.message && (
                      <div className="text-xs text-red-500 flex flex-row-reverse">
                        <span>{errors.eventDateTime.message}</span>
                      </div>
                    )}
                  </div>

                  <div className="md:w-1/2 w-full mb-6 md:ml-6">
                    <label className={labelClass} htmlFor="event-end-date">
                      Select End Date & Time
                    </label>
                    <input
                      className={classNames({
                        [inputClass]: true,
                        [inputErrorClass]:
                          errors.eventEndDateTime &&
                          errors.eventEndDateTime.message,
                      })}
                      type="datetime-local"
                      id="event-end-date"
                      placeholder="Event End date"
                      name="eventEndDateTime"
                      disabled={eventId ? true : false}
                      ref={register}
                    />
                    {errors.eventEndDateTime &&
                      errors.eventEndDateTime.message && (
                        <div className="text-xs text-red-500 flex flex-row-reverse">
                          <span>{errors.eventEndDateTime.message}</span>
                        </div>
                      )}
                  </div>
                </div>

                {/* Kahoot Options */}
                {location === 0 && (
                  <div className="md:flex">
                    <div className="md:w-1/2 w-full mb-6">
                      <label className={labelClass} htmlFor="eventHostingSite">
                        Sitename
                      </label>
                      <input
                        className={classNames({
                          [inputClass]: true,
                          [inputErrorClass]:
                            errors.hostingSite && errors.hostingSite.message,
                        })}
                        id="hostingSite"
                        type="text"
                        placeholder="Please enter the event hosting sitename"
                        name="hostingSite"
                        ref={register}
                      />
                      {errors.hostingSite && errors.hostingSite.message && (
                        <div className="text-xs text-red-500 flex flex-row-reverse">
                          <span>{errors.hostingSite.message}</span>
                        </div>
                      )}
                    </div>

                    <div className="md:w-1/2 w-full mb-6 md:ml-6">
                      <label className={labelClass} htmlFor="event-link">
                        Meeting Link
                      </label>
                      <input
                        className={classNames({
                          [inputClass]: true,
                          [inputErrorClass]:
                            errors.meetingLink && errors.meetingLink.message,
                        })}
                        id="meetingLink"
                        type="text"
                        placeholder="Please enter the meeting link"
                        name="meetingLink"
                        ref={register}
                      />
                      {errors.meetingLink && errors.meetingLink.message && (
                        <div className="text-xs text-red-500 flex flex-row-reverse">
                          <span>{errors.meetingLink.message}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="md:flex">
                  <div className="w-full mb-6">
                    <label className={labelClass} htmlFor="event-description">
                      Event Description
                    </label>
                    <textarea
                      rows="6"
                      className={classNames({
                        [inputClass]: true,
                        [inputErrorClass]:
                          errors.eventDescription &&
                          errors.eventDescription.message,
                      })}
                      id="event-description"
                      placeholder="Describe the event in 1000 characters."
                      name="eventDescription"
                      ref={register}
                    />
                    {errors.eventDescription &&
                      errors.eventDescription.message && (
                        <div className="text-xs text-red-500 flex flex-row-reverse">
                          <span>{errors.eventDescription.message}</span>
                        </div>
                      )}
                  </div>
                </div>

                <div className="md:flex">
                  <div className="md:w-1/2 w-full mb-6 md:pr-4">
                    <div>
                      <input
                        onChange={handleImageChange}
                        id="learningIconOne"
                        type="file"
                        name="learningIconOne"
                        hidden
                      />
                      {imageLoading && <LinearProgress />}
                      <div onClick={handleImageClick}>
                        <img
                          id="learningIcon1"
                          src={
                            // learningIcon_1 !== undefined &&
                            // learningIcon_1 !== ""
                            //   ? learningIcon_1
                            //   : "https://i.ibb.co/9qyyh8K/learning-icon.png"
                            learningIconOne
                          }
                          alt="learning-icon"
                          width="156px"
                          border="0"
                        />
                      </div>
                    </div>
                    <div className="py-8">
                      <label className={labelClass} htmlFor="event-name">
                        Learning Icon - 1
                      </label>
                      <input
                        className={classNames({
                          [inputClass]: true,
                          [inputErrorClass]:
                            errors.learningIcon_1_desc &&
                            errors.learningIcon_1_desc.message,
                        })}
                        id="learning-icon-1-desc"
                        type="text"
                        placeholder="Describe in 50 characters."
                        name="learningIcon_1_desc"
                        ref={register}
                      />
                      {errors.learningIcon_1_desc &&
                        errors.learningIcon_1_desc.message && (
                          <div className="text-xs text-red-500 flex flex-row-reverse">
                            <span>{errors.learningIcon_1_desc.message}</span>
                          </div>
                        )}
                      <input
                        className={classNames({
                          [inputClass]: true,
                          [inputErrorClass]:
                            errors.learningIcon_1_link &&
                            errors.learningIcon_1_link.message,
                        })}
                        id="learning-icon-1-link"
                        // id='learningIconOne'
                        onChange={() => {
                          setLearningIconOne(learningIcon_1);
                          learningIcon_1 = "";
                        }}
                        type="text"
                        placeholder="Enter URL for learning icon 1 (Optional)"
                        name="learningIcon_1_link"
                        ref={register}
                      />
                      {errors.learningIcon_1_link &&
                        errors.learningIcon_1_link.message && (
                          <div className="text-xs text-red-500 flex flex-row-reverse">
                            <span>{errors.learningIcon_1_link.message}</span>
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="md:w-1/2 w-full mb-6 md:pl-4">
                    <div>
                      <input
                        onChange={handleImageChange}
                        id="learningIconTwo"
                        type="file"
                        name="learningIconTwo"
                        hidden
                      />
                      {imageLoading && <LinearProgress />}
                      <div onClick={handleImageClick}>
                        <img
                          id="learningIcon2"
                          src={
                            // learningIcon_2 !== undefined &&
                            // learningIcon_2 !== ""
                            //   ? learningIcon_2
                            //   : "https://i.ibb.co/9qyyh8K/learning-icon.png"
                            learningIconTwo ||
                            "https://i.ibb.co/9qyyh8K/learning-icon.png"
                          }
                          alt="learning-icon"
                          width="156px"
                          border="0"
                        />
                      </div>
                    </div>
                    <div className="py-8">
                      <label className={labelClass} htmlFor="event-name">
                        Learning Icon - 2
                      </label>
                      <input
                        className={classNames({
                          [inputClass]: true,
                          [inputErrorClass]:
                            errors.learningIcon_2_desc &&
                            errors.learningIcon_2_desc.message,
                        })}
                        id="learning-icon-2-desc"
                        type="text"
                        placeholder="Describe in 50 characters."
                        name="learningIcon_2_desc"
                        ref={register}
                      />
                      {errors.learningIcon_2_desc &&
                        errors.learningIcon_2_desc.message && (
                          <div className="text-xs text-red-500 flex flex-row-reverse">
                            <span>{errors.learningIcon_2_desc.message}</span>
                          </div>
                        )}
                      <input
                        className={classNames({
                          [inputClass]: true,
                          [inputErrorClass]:
                            errors.learningIcon_2_link &&
                            errors.learningIcon_2_link.message,
                        })}
                        id="learning-icon-2-link"
                        // id='learningIconTwo'
                        onChange={() => {
                          setLearningIconTwo(learningIcon_2);
                          learningIcon_2 = "";
                        }}
                        type="text"
                        placeholder="Enter URL for learning icon 2 (Optional)"
                        name="learningIcon_2_link"
                        ref={register}
                      />
                      {errors.learningIcon_2_link &&
                        errors.learningIcon_2_link.message && (
                          <div className="text-xs text-red-500 flex flex-row-reverse">
                            <span>{errors.learningIcon_2_link.message}</span>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div className="md:flex">
                  <div className="w-full mb-6">
                    <input
                      className="mb-4"
                      type="checkbox"
                      ref={register}
                      name="showEventDisclaimer"
                    />
                    {"  "}
                    <span>Do you want to add event disclaimers?</span>
                  </div>
                </div>
                {showEventDisclaimer && (
                  <div className="md:flex">
                    <div className="w-full mb-6">
                      <label className={labelClass} htmlFor="event-description">
                        Event Disclaimer
                      </label>
                      <textarea
                        rows="6"
                        className={classNames({
                          [inputClass]: true,
                          [inputErrorClass]:
                            errors.eventDisclaimer &&
                            errors.eventDisclaimer.message,
                        })}
                        id="event-disclaimer"
                        placeholder="Mention the event rules and regulations in 1000 characters."
                        name="eventDisclaimer"
                        ref={register}
                      />
                      {errors.eventDisclaimer &&
                        errors.eventDisclaimer.message && (
                          <div className="text-xs text-red-500 flex flex-row-reverse">
                            <span>{errors.eventDisclaimer.message}</span>
                          </div>
                        )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr className="border border-b-0 border-black border-opacity-25" />
            <div className="lg:flex my-16">
              <div className="lg:mr-6 max-w-xs">
                <h4 className="font-medium text-2xl leading-7">Host Details</h4>
              </div>
              <div className="lg:mt-0 my-8 w-full">
                <div className="md:w-1/2 w-full mb-6">
                  <div className="md:px-12">
                    <input
                      onChange={handleImageChange}
                      id="hostProfilePicture"
                      type="file"
                      name="hostProfilePicture"
                      hidden
                    />
                    {imageLoading && <LinearProgress />}
                    <div onClick={handleImageClick}>
                      <img
                        id="hostProfilePic"
                        width="238px"
                        src={
                          // hostPicUrl !== undefined && hostPicUrl !== ""
                          //   ? hostPicUrl
                          //   : "https://i.ibb.co/MVzzRLk/host-pic-placeholder.png"
                          hostProfilePicture
                        }
                        alt="host-pic-placeholder"
                        border="0"
                      />
                    </div>
                  </div>
                </div>

                <div className="md:flex md:px-12">
                  <div className="md:w-1/2 w-full mb-6 md:pr-4">
                    <label className={labelClass} htmlFor="host-credentials">
                      Host Picture URL (Optional)
                    </label>

                    <input
                      className={classNames({
                        [inputClass]: true,
                        [inputErrorClass]:
                          errors.hostPicUrl && errors.hostPicUrl.message,
                      })}
                      id="host-pic-url"
                      type="text"
                      placeholder="Host picture URL"
                      name="hostPicUrl"
                      onChange={() => {
                        setHostProfilePicture(hostPicUrl);
                        hostPicUrl = "";
                      }}
                      ref={register}
                    />
                    {errors.hostPicUrl && errors.hostPicUrl.message && (
                      <div className="text-xs text-red-500 flex flex-row-reverse">
                        <span>{errors.hostPicUrl.message}</span>
                      </div>
                    )}
                  </div>
                  <div className="md:w-1/2 w-full mb-6 md:pl-4">
                    <label className={labelClass} htmlFor="host-name">
                      Host Name
                    </label>

                    <input
                      className={classNames({
                        [inputClass]: true,
                        [inputErrorClass]:
                          errors.hostName && errors.hostName.message,
                      })}
                      id="host-name"
                      type="text"
                      placeholder="Full Name"
                      name="hostName"
                      ref={register}
                    />
                    {errors.hostName && errors.hostName.message && (
                      <div className="text-xs text-red-500 flex flex-row-reverse">
                        <span>{errors.hostName.message}</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="md:flex md:px-12">
                  <div className="w-full mb-6">
                    <label className={labelClass} htmlFor="host-credentials">
                      Host Credentials
                    </label>

                    <input
                      className={classNames({
                        [inputClass]: true,
                        [inputErrorClass]:
                          errors.hostCredentials &&
                          errors.hostCredentials.message,
                      })}
                      id="host-credentials"
                      type="text"
                      placeholder="Host credentials e.g. CEO, Next Ventures"
                      name="hostCredentials"
                      ref={register}
                    />
                    {errors.hostCredentials && errors.hostCredentials.message && (
                      <div className="text-xs text-red-500 flex flex-row-reverse">
                        <span>{errors.hostCredentials.message}</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="md:flex md:px-12">
                  <div className="w-full mb-6">
                    <label className={labelClass} htmlFor="host-description">
                      Host Description
                    </label>
                    <textarea
                      rows="6"
                      className={classNames({
                        [inputClass]: true,
                        [inputErrorClass]:
                          errors.hostDescription &&
                          errors.hostDescription.message,
                      })}
                      id="host-description"
                      placeholder="Describe your host in 1000 characters."
                      name="hostDescription"
                      ref={register}
                    />
                    {errors.hostDescription && errors.hostDescription.message && (
                      <div className="text-xs text-red-500 flex flex-row-reverse">
                        <span>{errors.hostDescription.message}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr className="border border-b-0 border-black border-opacity-25" />
            <div className="lg:flex my-16">
              <div className="lg:mr-6 max-w-xs">
                <h4 className="font-medium text-2xl leading-7">
                  Event Reminders
                </h4>
              </div>
              <div className="lg:mt-0 my-8 w-full">
                <div className="md:flex">
                  <div className="w-full mb-6 pr-4">
                    <label className={labelClass} htmlFor="event-name">
                      Send reminders to Registered Participants (Upto 3
                      reminders)
                    </label>
                    <p className="text-gray-600 text-sm mb-10">
                      Set custom time patterns to send reminders to members who
                      have registered for the event
                    </p>
                    {timeTags.map((tag, i) => (
                      <button
                        className={classNames(
                          "px-2 py-2 mr-2 mb-2 rounded-sm",
                          {
                            "bg-tagBackground": !tag.selected,
                          },
                          {
                            "bg-white border-black border-2 border-solid":
                              tag.selected,
                          }
                        )}
                        key={i}
                        type="button"
                        onClick={() => {
                          toggleTimeTagSelectedState(i);
                        }}
                      >
                        {tag.text}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {error && (
            <div className="error-footer">
              <ErrorFooter message={error} />
            </div>
          )}

          <div>
            <div className="shadow-lg bottom-0 w-full flex md:justify-end justify-center py-4 px-8 border border-b-2 items-center">
              <button
                disabled={loading}
                type="submit"
                className="bg-yellow-500 py-4 px-16 rounded font-bold text-sm tracking-widest leading-4 uppercase outline-none"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEvent;
